export default {
  userInfo: (state) => state.userInfo.userInfo,
  name: (state) => state.userInfo.name,
  roles: (state) => state.userInfo.roles,
  permissions: (state) => state.userInfo.permissions,
  routes: (state) => state.permission.routes,
  routeTabs: (state) => state.permission.routeTabs,
  subSystemName: (state) => state.permission.subSystemName,
  subSystemId: (state) => state.permission.subSystemId,
};
